// src/pages/QuestionnairePage.jsx
/* ------------------------------------------------------------------ */
/* QuestionnairePage – dynamic assessment hub                         */
/* ------------------------------------------------------------------ */
/**
 * Routes handled
 * --------------
 * • `/questionnaire`                 → `<QuestionnaireChooser />`
 * • `/questionnaire/:questionnaire`  → `<DynamicQuestionnaireForm />`
 *
 * Design notes
 * ------------
 * 1. The “chooser” UI was split into its own component for clarity and reuse.
 * 2. The list of available assessments lives in a single **`QUESTIONNAIRES`**
 *    array so adding / removing a questionnaire is a single-line diff and
 *    easily unit-testable.
 *
 * Future work
 * -----------
 * • Move `QUESTIONNAIRES` to `utils/questionnaireRegistry.js` if other
 *   surfaces (e.g. dashboard, side-menu) also need the list.
 * • Promote `<QuestionnaireChooser/>` into `components/questionnaire/`
 *   if a mobile layout or other page needs to re-use it.
 *
 * @component
 * @returns {JSX.Element}
 */

import React, { memo } from "react";
import { useParams } from "react-router-dom";
import DynamicQuestionnaireForm from "../components/questionnaire/DynamicQuestionnaireForm";
import { QuestionnaireChooser } from "../components/questionnaire/QuestionnaireChooser";

/* ------------------------------------------------------------------ */
/* Main component                                                     */
/* ------------------------------------------------------------------ */
function QuestionnairePage({ selectedPatient }) {
  const { questionnaireName } = useParams();

  /* ---------- No slug → show list ----------------------------- */
  if (!questionnaireName) {
    return <QuestionnaireChooser />;
  }

  /* ---------- Slug present → render form ---------------------- */
  return (
    <div className="form-page w-full h-full max-w-lg p-4">
      <DynamicQuestionnaireForm selectedPatient={selectedPatient} />
    </div>
  );
}

export default memo(QuestionnairePage);
